import dayjs from "dayjs";
import { AlunoCurso } from "../models";
import { alunoCursoCalcDates } from "./aluno-curso-calc-dates";

export function alunoCursoFinalDate(alunoCurso: Partial<AlunoCurso>) {
  if (!alunoCurso.data_inicio || !alunoCurso.planos?.length) return '';
  const dates = (alunoCursoCalcDates(alunoCurso) as any[]);
  return dayjs(dates[dates.length - 1].date).format('DD/MM/YYYY');
}